<!-- This is a test -->

<div class="modal-header">
    <h1 class="modal-title" id="modal-basic-title">Login</h1>
    <span>
        Not User ? <a href="#" class="login" routerLink="/sign-up" (click)="activeModal.close(false)"> Register Here
        </a>
    </span>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
        (click)="activeModal.close(false)">
    </button>
</div>

<div class="modal-body">
    <form>
        <div class="mb-3">
            <label for="loginId" class="form-label" position="floating">Login Id</label>

            <div class="input-group">
                <input [(ngModel)]="viewModel.tokenRequest.loginId" [ngModelOptions]="{standalone: true}"
                    class="form-control" placeholder="Enter a valid email address" />
            </div>
            <!-- <div class="error-message" *ngIf="viewModel.hasValidationError('loginId')">
                {{viewModel.getValidationMessage("loginId") }}
            </div> -->
        </div>

        <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <div class="input-group">
                <input [(ngModel)]="viewModel.tokenRequest.password" [ngModelOptions]="{standalone: true}"
                    class="form-control" placeholder="Enter a valid password" name="password"
                    [type]="viewModel.hide ? 'password' : 'text'" />

                <span class="password" (click)="togglePassword()">
                    <i class="bi bi-eye-fill" [ngClass]="[viewModel.eyeDefault]"> {{viewModel.hide ? '' : ''}} </i>
                </span>
            </div>

            <!-- <div class="error-message" *ngIf="viewModel.hasValidationError('password')">
                {{viewModel.getValidationMessage("password") }}
            </div> -->
        </div>

        <div class="text-center">
            <input type="checkbox" class="form-check-input me-2" value="" />
            <label class="form-check-label" [(ngModel)]="viewModel.rememberMe">
                Remember me
            </label>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn loginButton" (click)="click_Login()">Login</button>
</div>